
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationError } from "@/app/dynamic-components/forms/form-validations/form-validator.base";

@Component({
  components: {},
})
export default class AeTimePicker extends Vue {
  @Prop({ default: [] })
  errors!: ValidationError[];
  @Prop({ default: [] })
  errorMessages!: string[];

  @Prop({ default: null })
  value!: Date;

  @Prop({ default: null })
  label!: string;

  @Prop({ default: false })
  required!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  menu = false;
  timePicked: string | Date | null = null;
  hours = "0";
  minutes = "0";

  mounted(): void {
    this.initializeTimePicked();
  }

  @Watch("value")
  private initializeTimePicked() {
    if (this.value) {
      //this.value is a string in ISO format
      const initialDate = new Date(this.value);
      const timePicked = initialDate.getHours().toString().padStart(2, "0") + ":" + initialDate.getMinutes().toString().padStart(2, "0");
      if(timePicked !== this.timePicked){
        this.timePicked = timePicked;
        this.hours = initialDate.getHours().toString();
        this.minutes = initialDate.getMinutes().toString();
      }

    } else {
      this.timePicked = null;
      this.hours = "0";
      this.minutes = "0";
    }
  }

  private limitInput(event: any, fieldName: string, maxValue: number): void {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (allowedKeys.includes(event.key)) return;

    if (event.ctrlKey || event.metaKey) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    const currentValue = this[fieldName]?.toString() || "";

    if (currentValue.length === 0) return;

    if (currentValue.length >= 2) {
      event.preventDefault();
      return;
    }

    let nextValue = currentValue + event.key;
    const numericValue = parseInt(nextValue, 10);

    if (nextValue.length > 2 || isNaN(numericValue) || numericValue > maxValue) {
      event.preventDefault();
    }
  }

  private limitPaste(event: any, fieldName: string, maxValue: number) {
    const paste = event.clipboardData.getData('text').trim();

    if (paste === '') {
      this[fieldName] = '';
      event.preventDefault();
      return;
    }

    if (!/^\d{1,2}$/.test(paste)) {
      event.preventDefault();
      return;
    }

    const numericValue = parseInt(paste, 10);

    if (isNaN(numericValue) || numericValue > maxValue) {
      event.preventDefault();
      return;
    }

    // Valid paste — assign manually
    this[fieldName] = paste;
    event.preventDefault();
  }

  private timeValueChangedHours(): void{
    if(!this.$refs.hourinput) return;
    const inputEl = this.$refs.hourinput['$el'].querySelector('input');
    this.timeValueChanged(inputEl);
  }

  private timeValueChangedMinutes(): void{
    if(!this.$refs.minuteinput) return;
    const inputEl = this.$refs.minuteinput['$el'].querySelector('input');
    this.timeValueChanged(inputEl);
  }

  private timeValueChanged(inputEl): void {
    if(!isNaN(parseInt(this.hours)) && !isNaN(parseInt(this.minutes))) {
      this.pickerValueChanged(`${this.hours}:${this.minutes}`);
    }
  }

  private pickerValueChanged(newValue: string): void {
    this.timePicked = newValue;

    if (this.timePicked) {
      this.emitDate(this.timePicked);
    }
  }

  private emitDate(date: string): void {
    const [hours, minutes] = date.split(":");
    let datePicked = new Date();
    if (!this.value) {
      const today = new Date();
      datePicked = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number.parseInt(hours),
        Number.parseInt(minutes),
        0
      );
    } else {
      const initialDate = new Date(this.value);
      datePicked = new Date(
        initialDate.getFullYear(),
        initialDate.getMonth(),
        initialDate.getDate(),
        Number.parseInt(hours),
        Number.parseInt(minutes),
        0
      );
    }

    this.$emit("input", datePicked);
  }
}
